import { colors } from "@mui/material";
import customColors from "./colors";

const palette = {
  black: customColors.black,
  white: customColors.white,
  primary: {
    contrastText: customColors.white,
    dark: customColors.darkBlue,
    main: customColors.brandingBlue,
    light: colors.blue[100],
  },
  secondary: {
    contrastText: customColors.darkBlue,
    dark: colors.yellow[700],
    main: customColors.yellow,
    light: colors.yellow[300],
  },
  success: {
    contrastText: customColors.white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: customColors.white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: customColors.white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: customColors.white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: customColors.brandingBlue,
  },
  background: {
    default: customColors.white,
    paper: customColors.white,
  },
  button: {
    primary: {
      fill: customColors.yellow,
      text: customColors.blue,
    },
    secondary: {
      fill: customColors.greyBlue,
      text: customColors.blue,
      disabledButton: customColors.disabledButton,
    },
    disabled: {
      fill: customColors.disabledButton,
      text: customColors.disabledText,
    },
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};

export default palette;
